<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" id="modal" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div style="margin:0 auto; text-align: center;">
		<div class="matTitulo">
			<i class="fal fa-file-search" id="ico"></i>
			<h1 class="titulo" style="display:inline-block;">Histórico de Posiciones</h1>
		</div>
		<mat-divider></mat-divider>
	</div>
</div>
<mat-card class="mt-2">
	<mat-card-content class="card-content">
		<div class="row">
			<div class="col-lg-12 col-xl-12">
				<h4 *ngIf="descripcion">{{descripcion.descripcion}}</h4>
			</div>
			<div class="col-lg-12 col-xl-8">
				<span>Especifique un rango de tiempo en el cual desea obtener ubicaciones del vehiculo
					seleccionado.
				</span>
			</div>
			<div class="col-lg-12 col-xl-4">
				<div class="row">
					<button id="boton" type="submit" class="btn btn-success" [disabled]="botonGraficasDisabled" (click)="verGraficas()">
						<i class="fal fa-analytics"></i>Gráficas
					</button>&nbsp;
					<kt-boton-exportar-tabla [style]="{'margin-left': '1px'}" [tipoBoton]="'monitoreo'"
						[nombreArchivo]="'Historico_Posiciones_Vehiculo'" [datos]="datosReporte"
						[buttonDisabled]="isDisable">
					</kt-boton-exportar-tabla>&nbsp;
				</div>
			</div>
		</div>
		<br> <mat-divider></mat-divider>
		<dx-validation-group #targetGroup>
			<div class="row">
				<div class="col-lg-12 col-xl-8">
					<div class="row mt-4">
						<div class="col-md-6">
							<label>Fecha Inicial</label>
							<dx-date-box [(value)]="fechaInicio" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
						<div class="col-md-6">
							<label>Fecha Final</label>
							<dx-date-box [(value)]="fechaFin" type="datetime" style="width: 100%;"
								displayFormat="yyyy-MM-dd HH:mm:ss">
								<dx-validator>
									<dxi-validation-rule message="Campo requerido" type="required">
									</dxi-validation-rule>
								</dx-validator>
							</dx-date-box>
						</div>
					</div>
				</div>
				<div class="col-lg-12 col-xl-4 botones">
					<div class="row mt-1">
						<button id="boton" type="submit" class="btn btn-success"
							(click)="reportePosicion(fechaInicio, fechaFin)">
							<i class="fal fa-search"></i>Buscar
						</button>&nbsp;
						<button id="botonAlDia" type="submit" class="btn btn-success" (click)="reporteAlDia()">
							<i class="fal fa-clock"></i>Al día
						</button>&nbsp;
						<!--<button *ngIf="idCliente == 39" id="botonReproduccion" type="submit" class="btn btn-success"
							(click)="reproducciones()"><i class="fal fa-play"></i>Video</button>&nbsp;-->
					</div>
				</div>

			</div>
		</dx-validation-group>
		<br *ngIf="showTable"> <mat-divider *ngIf="showTable" class="mt-3"></mat-divider>
		<div class="grid">
			<dx-data-grid *ngIf="showTable" id="gridContainer" [columnHidingEnabled]="true" [dataSource]="reportePos"
				[showBorders]="true">
				<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
				<dxo-paging [pageSize]="5"></dxo-paging>
				<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
				</dxo-pager>
				<dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center" [width]="100">
				</dxi-column>
				<dxi-column dataField="fecha" alignment="center" dataType="date" format="shortDateShortTime"
					[width]="200">
					<dxo-header-filter [dataSource]="orderHeaderFilter"></dxo-header-filter>
				</dxi-column>
				<dxi-column dataField="placas" alignment="center" caption="Placa"></dxi-column>
				<dxi-column dataField="ignicion" alignment="center" caption="Ignición"></dxi-column>
				<dxi-column dataField="estado" alignment="center" caption="Estado"></dxi-column>
				<dxi-column dataField="velocidad" alignment="center" caption="Velocidad Km/h" cellTemplate="velocidad"></dxi-column>
				<dxi-column dataField="lat" alignment="center" caption="Latitud" [hidingPriority]="1">
				</dxi-column>
				<dxi-column dataField="lng" alignment="center" caption="Longitud" [hidingPriority]="1">
				</dxi-column>
				<div *dxTemplate="let d of 'Abrir'" (click)="ubicarPuntoHistorico(d.data)" style="text-align: center;">
					<dx-button style="background-color: #fff;" class="btnAcciones">
						<i class="fa fa-eye" style="color:#166BA2"></i>
					</dx-button>
				</div>
				<div *dxTemplate="let v of 'velocidad'" (click)="ubicarPuntoHistorico(d.data)" style="text-align: center;">
					<span>{{v.data.velocidad}} km/h</span>
				</div>
			</dx-data-grid>
		</div>
	</mat-card-content>
</mat-card>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false" message="Cargando...">
</dx-load-panel>
